<customer-wrapper>
  <ng-container main-content>
    <div class="form-subsection-container custom-page-row">
      <div class="page-title">
        <img src="assets/icons/list.svg">
        <div>Customer List</div>
        <div class="results-count">[{{resultsLength}}]</div>
      </div>
      <div class="header-buttons">
          <button routerLink="./add" class="default-custom-button  customer-button add-button custom-button custom-button-flat">
            <div class="icon-wrapper custom-button-icon">
              <img src="assets/icons/add.svg">
            </div>
            <div class="button-text-wrapper">Add Customer</div>
          </button>
      </div>
    </div>

    <div class="custom-page-row" [formGroup]="form">
        <free-search formControlName = "search" [searchOptions]="searchProperties"/>
        <custom-dropdown-list-container class="customer-sort">
          <div dropdown-toggle class="sort-toggle custom-box">
            <div class="custom-box-inner">
              <div class="icon-wrapper">
                <img src="assets/icons/sort.svg">
              </div>
              <div class="custom-box-text">Sort</div>
            </div>
          </div>
          <div class="sort-items-wrapper" dropdown-list>
            <div class="sort-items-top">
                <div class="sort-item custom-selectable-item" *ngFor="let option of sortOptions" (click)="sort(option.id)">
                  <div class="icon-wrapper">
                    <img src="assets/icons/check.svg" [class.unselected-sort-option]="sortBy.value !== option.id">
                  </div>
                  <div class="sort-item-inner">
                    {{option.name}}
                  </div>
                </div> 
            </div>
              <div class="sort-items-bottom">
                <div class="sort-item custom-selectable-item" (click)="setSortOrder(true)">
                  <div class="icon-wrapper">
                    <img src="assets/icons/check.svg" [class.unselected-sort-option]="!sortAsc.value">
                  </div>
                  <div>
                    Ascending
                  </div>
                </div>
                <div class="sort-item custom-selectable-item" (click)="setSortOrder(false)">
                  <div class="icon-wrapper">
                    <img src="assets/icons/check.svg" [class.unselected-sort-option]="sortAsc.value">
                  </div>
                  <div>
                    Descending
                  </div>
                </div>
            </div>
          </div>
        </custom-dropdown-list-container>
        <div class="custom-box filters-label">
          <div class="custom-box-inner">
            Filters:
          </div>
        </div>
        <custom-multi-select formControlName="selectedCustomerTypes" [items]="customerTypes" [itemType]="'Customer Types'"/>
        <button class="primary customer-reset-button custom-button custom-button-text" id="edit" type="submit" (click)="resetFilters()">
          Reset
        </button>
    </div>

    <span class="ml-2 badge badge-dark d-none d-sm-inline" *ngIf="filtered">Results are being filtered</span>

    <div class="position-relative">
      <h5 class="no-results text-center font-weight-bold py-3" *ngIf="resultsLength == 0 && !isLoadingResults">
        No Customers Found
      </h5>
      <div class="table-container">
        <table class="w-100" [class.d-none]="resultsLength == 0">
          <thead>
            <tr class="custom-table-header">
              <th style="width: 9%;">Customer Name</th>
              <th style="width: 9%;">Customer Type</th>
              <th style="width: 5%;" class="icon-cell">Enabled</th>
              <th style="width: 8%;" class="date-cell">Creation Date</th>
              <th style="width: 9%;">Subscription Plan</th>
              <th style="width: 7%;" class="date-cell">Start Date</th>
              <th style="width: 8%;">End Date</th>
              <th style="width: 23%;" class="long-column-header">
                <custom-tooltip [tooltipMessage]="'The values below shows allowance vs usage for each entity.'" class="tooltip-wrapper">
                  <span tooltip-hoverable>Subscription Details</span>
                </custom-tooltip>
              </th>
              <th style="width: 7%;">PO Number</th>
              <th style="width: 10%;">Customer Contact</th>
              <th style="width: 5%;" class="icon-cell">Edit</th>
            </tr>
          </thead> 
          <tbody>
            <tr class="sub-header">
              <td colspan="7"></td>
              <td colspan="1">
                <div class="subscription-details-header">
                  <custom-tooltip class="subscription-icon-wrapper" [tooltipMessage]="'Assets'">
                      <img src="assets/icons/bus.svg" tooltip-hoverable>
                  </custom-tooltip>
                  <custom-tooltip class="subscription-icon-wrapper" [tooltipMessage]="'Storage'">
                    <img src="assets/icons/database.svg" tooltip-hoverable>
                  </custom-tooltip>
                  <custom-tooltip class="subscription-icon-wrapper" [tooltipMessage]="'Incidents'">
                    <img src="assets/icons/bulletlist.svg" tooltip-hoverable>
                  </custom-tooltip>
                  <custom-tooltip class="subscription-icon-wrapper" [tooltipMessage]="'Users'">
                    <img src="assets/icons/group.svg" tooltip-hoverable>
                  </custom-tooltip>
                  <custom-tooltip class="subscription-icon-wrapper" [tooltipMessage]="'Stream Video'">
                    <img src="assets/icons/camera.svg" tooltip-hoverable>
                  </custom-tooltip>
                  <custom-tooltip class="subscription-icon-wrapper" [tooltipMessage]="'Redaction'">
                    <img src="assets/icons/seatbelt.svg" tooltip-hoverable>
                  </custom-tooltip>
                </div>
              </td>
              <td colspan="3"></td>
            </tr>
            <tr class="spinner-wrapper">
              <div class="loading-shade" *ngIf="isLoadingResults">
                <div class="loading-spinner"></div>
              </div>
            </tr>
            <tr *ngFor="let customer of customers" class="custom-table-row">
              <td (click)="gotoDeviceManagement(customer)">{{ customer.name }}</td>
              <td>{{ customer.customerType?.name }}</td>
              <td (click)="gotoDeviceManagement(customer)" class="icon-cell">
                <ng-container *ngIf="customer.enabled"><img class="true-icon" src="assets/icons/tick.svg" /></ng-container>
              </td>
              <td class="date-cell">{{ customer.formattedCreationDate }}</td>
              <td>{{ customer.subscriptionPlan }}</td>
              <td class="date-cell">{{ customer.formattedSubStartDate }}</td>
              <td class="date-cell">
                <div class="custom-cell-with-icon">
                  <div>{{ customer.formattedSubEndDate }}</div>
                    <div *ngIf="customer.subscriptionWarning" class="subicon-wrapper">
                      <custom-tooltip [tooltipMessage]="dateThresholdMessages[customer.subscriptionWarning]">
                          <img [ngClass]="'warning-'+customer.subscriptionWarning" 
                              [src]="'assets/icons/' + (customer.subscriptionWarning !== 'outOfContract' ? 'warning.svg' : 'do_not_disturb_on.svg')" tooltip-hoverable>
                      </custom-tooltip>
                    </div>
                </div>
              </td>
              <td>
                <div class="subscription-details-cell">
                  <div>{{ customer.formattedSubDetails.assetLimit }}</div>
                  <div>{{ customer.formattedSubDetails.storageLimit }}</div>
                  <div>{{ customer.formattedSubDetails.incidentCreationLimit }}</div>
                  <div>{{ customer.formattedSubDetails.concurrentUsersLimit }}</div>
                  <div>{{ customer.formattedSubDetails.liveVideoLimit }}</div>
                  <div>{{ customer.formattedSubDetails.redactionLimit }}</div>
                </div>
                <div class="subscription-details-cell customer-usage-values">
                  <div [ngClass]="'warning-' + customer.warningLevels.assets" > {{ customer.formattedSubDetails.assetUsage }} </div>
                  <div [ngClass]="'warning-' + customer.warningLevels.storage" > {{ customer.formattedSubDetails.storageUsed }} </div>
                  <div [ngClass]="'warning-' + customer.warningLevels.incidents" > {{ customer.formattedSubDetails.incidentsCreated }} </div>
                  <div [ngClass]="'warning-' + customer.warningLevels.users" > {{ customer.formattedSubDetails.loggedInUsers }} </div>
                  <div [ngClass]="'warning-' + customer.warningLevels.streaming"> {{ customer.formattedSubDetails.liveVideoStreamed }} </div>
                  <div [ngClass]="'warning-' + customer.warningLevels.redaction"> {{ customer.formattedSubDetails.redactedSeconds }} </div>
                </div>
              </td>
              <td class="secondary-column-cell">{{ customer.poNumber }}</td>
              <td class="secondary-column-cell">{{ customer.contact}}</td>
              <td class="icon-cell">
                <a (click)="navToCustomerEditForm(customer)"> <img class="edit-icon" src="assets/icons/pencil.svg" /></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>
</customer-wrapper>

<ng-container *ngIf="addingCustomer == true">
  <customer-form-modal
    [customer]="activeCustomer"
    [triggerRefresh]="forceTableRefresh"
    (close)="modalClosed()"></customer-form-modal>
</ng-container>
